import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TaskTypeDrawerService, TaskTypeDrawerOptions } from '../../../services/task-type-drawer.service';
import { TaskTypesFormComponent } from '../task-types-form/task-types-form.component';
import { TaskTypeResponse } from '../../../models/task.model';
import { ToastService } from '../../../../../shared/services/toast.service';

@Component({
  selector: 'app-task-types-form-drawer',
  standalone: true,
  imports: [CommonModule, TaskTypesFormComponent],
  template: `
    @if (isOpen) {
      <div class="fixed inset-0 z-drawer bg-black/40" (click)="close()"></div>
    }

    <div
      class="fixed top-0 right-0 z-drawer h-full w-full max-w-2xl bg-white dark:bg-gray-900 flex flex-col transition-transform duration-300 ease-in-out overflow-hidden"
      [class.shadow-2xl]="isOpen"
      [class.translate-x-0]="isOpen"
      [class.translate-x-full]="!isOpen"
    >
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ options.typeId ? 'Editar tipo de tarea' : 'Nuevo tipo de tarea' }}
        </h2>
        <button type="button" (click)="close()"
          class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto">
        @if (isOpen) {
          <app-task-types-form [drawerMode]="true" (saved)="onSaved($event)" (cancelled)="onCancelled()"/>
        }
      </div>
    </div>
  `,
})
export class TaskTypesFormDrawerComponent implements OnInit, OnDestroy {
  @ViewChild(TaskTypesFormComponent) formComponent?: TaskTypesFormComponent;

  isOpen = false;
  options: TaskTypeDrawerOptions = {};
  private readonly destroy$ = new Subject<void>();

  constructor(private drawerService: TaskTypeDrawerService, private toast: ToastService) {}

  ngOnInit(): void {
    this.drawerService.state.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      const wasOpen = this.isOpen;
      this.isOpen = state.isOpen;
      this.options = state.options;
      if (state.isOpen && !wasOpen) {
        setTimeout(() => {
          if (this.formComponent) {
            this.formComponent.reset();
            if (state.options.typeId) this.formComponent.loadItem(state.options.typeId);
          }
        }, 0);
      }
    });
  }

  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  onSaved(item: TaskTypeResponse): void {
    if (this.options.typeId) {
      this.toast.updated('Tipo de tarea', `Se actualizó "${item.label || item.name}" correctamente.`);
    } else {
      this.toast.created('Tipo de tarea', `Se creó "${item.label || item.name}" correctamente.`);
    }
    this.drawerService.notifySaved(item);
    this.drawerService.close();
  }
  onCancelled(): void { this.drawerService.close(); }
  close(): void { this.drawerService.close(); }
}
